import classes from "./Kiosk_viennaPlzen_redesign.module.css";
import {React, useEffect, useState} from "react";
import bck from "../../../store/Vienna/defScr/2f529311-d03d-46a3-a5e1-01aecce4543b.jpg";
import bck2 from "../../../store/Vienna/defScr/fe64807a-76d3-44d9-9a9a-8120d3fe7314.jpg";
import bck3 from "../../../store/Vienna/defScr/2ff1fb60-d141-4d82-b0a9-ed61115c7b56.jpg";
import bck4 from "../../../store/Vienna/defScr/b9400740-ea13-4683-829b-52e3920a0b6e.jpg";
import bck5 from "../../../store/Vienna/defScr/1475152f-9ee7-4e15-91cb-4961525d1e15.jpg";
import axios from "axios";
import {path} from "../../../routes";
import Tl1 from "../../../store/meet_1.jpg";
import Tl2 from "../../../store/rest_1.jpg";
import Tl3 from "../../../store/rooms_1.jpg";
import Tl4 from "../../../store/jazzbar_1.jpg";
import {CircularProgress} from "@mui/material";
import logo from "../../../store/Vienna/vh_easy_by_WYndham_prop_logo_Pilsen_cmyk.png";
import cloud from "../../../store/cloud-icon-17.png";
import backMenu from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Exterior - bez transparentu.jpg"
import video from "../../../store/Vienna_new/video.mp4"
import cnn from "../../../store/Vienna_new/Cnn_logo_red_background.png"
import room from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Executive Double Room - 1550170.jpg"
import back from "../../../store/Vienna_new/back-flat-color-outline-icon-free-png.webp"
import suproom from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Superior Double Room - 1550188.jpg"
import Sleep from "./VIENNA_PLZEN/Sleep";
import Eat from "./VIENNA_PLZEN/Eat";
import Meet from "./VIENNA_PLZEN/Meet";
import {Expand, Explore} from "@mui/icons-material";
import ExploreVienna from "./VIENNA_PLZEN/Explore";
import MeetingGraph from "./KioskPages/MeetingGraph";
import MeetingStairs from "./KioskPages/MeetingStairs";
import Bar from "./KioskPages/Bar";
import SlideShowKiosk_redesign from "./KioskPages/SlideShowKiosk_redesign";

const Kiosk_viennaPlzen_redesign = (props) => {
    const [backgrounds, setBackgrounds] = useState([bck, bck2, bck3, bck4, bck5]);
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [currentIndexnews, setCurrentIndexnews] = useState(0);
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [news, setNews] = useState([]);
    const [news2, setNews2] = useState();

    const [newsData, setNewsData] = useState([]);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [state, setState] = useState(0);
    const [language, setLanguage] = useState(0);
    const [footerShow, setfooterShow] = useState(2);
    const [bodyRes, setbodyRes] = useState(2);
    const [step, setStep] = useState(0);
    const [group, setGroup] = useState(1);
    // Header (logo/čas/datum) chceme zobrazovat i když backend zrovna spadne (500 apod.)
    const [header, setHeader] = useState(true);
    const [newstep, setNewStep] = useState(0);
    const ORG_ID_VIENNA_PLZEN = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';
    const deviceId = props.id == 1 ? 40 : 41;

    const fetch_meetings = async () => {
        let state = (await getDevice())
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(ORG_ID_VIENNA_PLZEN)}&day=${encodeURIComponent(actTime)}`);
            decision_handler(response.data, state)
        } catch (error) {
            console.log(error)
            // Fallback: backend error → neschovávat header
            setHeader(true);
            setStep(0)
        }

    }

    const getDevice = async () => {
        try {
            const response = await axios.get(`${path}/getRoomDetail/${deviceId}`);
            const kioskState = Number(response.data[0]?.KioskState);
            const stateNum = (kioskState === 0 || kioskState === 1 || kioskState === 2) ? kioskState : 0;
            setState(stateNum);
            return stateNum;
        } catch (err) {
            console.error(err);
            return 0;
        }
    }

    const decision_handler = (x, y) => {
        const stateNum = Number(y);
        const yNorm = (stateNum === 0 || stateNum === 1 || stateNum === 2) ? stateNum : 0;
        switch (yNorm) {
            case 0: {
                console.log(":0")
                setHeader(true)
                if (x.length != 0) {
                    if (props.id == 1) {
                        setNewStep(11)
                        setGroup(1)
                        //setStep(11)
                    }
                    if (props.id == 2) {
                        setNewStep(10)
                        //setStep(7)
                    }
                }
                if (x.length == 0) {
                    if (props.id == 1) {
                        //setGroup(1)
                        //setStep(11)
                        setNewStep(0)
                        //setStep(10)
                    }
                    if (props.id == 2) {
                        // dřív se nastavoval "step", ale UI se řídí "newstep" → zůstávalo zaseknuté ve starém módu
                        setNewStep(0)
                        setGroup(6)

                    }
                }
                break
            }
            case 1: {
                setHeader(true)
                console.log(":1")
                setNewStep(12)
                setGroup(props.id == 1 ? 21 : 22)
                break
            }
            case 2: {
                // I ve fullscreen variantě (Default kiosk graphics) chceme mít nahoře logo/čas/datum
                setHeader(true)
                console.log(":2")
                setNewStep(12)
                setGroup(props.id == 1 ? 21 : 22)
                break
            }
        }

    }

    const fetchNews = async (gr) => {
        try {
            let tmp = []
            const response = await axios.get(`${path}/getNews`);
            for (let i = 0; i < response.data.length; i++) {
                tmp.push(response.data[i].description)
            }
            setNews(tmp)
            console.log(tmp)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const resetscreen = () => {
        console.log("reset screen")
        setNewStep(0)
    };

    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST WITHOUT FOOTER
    9 - MEETING DETAIL WITHOUT FOOTER
    * */
    const changeStep_handler = (step) => {
        setStep(step);
    }
    const changeGroup_handler = (id) => {
        setGroup(id);
    }
    const reload_handler = () => {
        console.log("reload_handler")
    }

    useEffect(() => {

        const apiKeyNews = '103cea4011e44292b5c47cd9c7808d1c';
        const apiUrlNews = `https://newsapi.org/v2/top-headlines?country=us&apiKey=${apiKeyNews}`;
        const apiKeyWea = '53aaf5c2175c0194becf66b6a9f26436';
        const city = 'Praha';
        const apiUrlWea = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKeyWea}&units=metric`;

        const fetchWeather = async () => {
            try {
                const response = await fetch(apiUrlWea);
                if (!response.ok) {
                    throw new Error('Chyba při načítání dat o počasí');
                }
                const data = await response.json();
                setWeatherData(Math.round(data.main.temp));
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };
        updateMinute()
        const intervalId = setInterval(updateMinute, 1000);

        fetchWeather();
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % backgrounds.length);
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [backgrounds]);

    useEffect(() => {
        const intervalIdNews = setInterval(() => {
            setCurrentIndexnews((prevIndex) => (prevIndex + 1) % news.length);
        }, 15000);
        return () => {
            clearInterval(intervalIdNews);
        };
    }, [news]);

    useEffect(() => {
        const intervalfetchmeeting = setInterval(() => {
            fetch_meetings()
        }, 60 * 1000);
        return () => {
            clearInterval(intervalfetchmeeting);
        };
    }, [news]);

    useEffect(() => {

        const hourDelay = 60 * 60 * 1000; // 1 hour in milliseconds
        const refreshPage = setTimeout(() => {
            console.log("reload_handler")
        }, hourDelay);


        return () => {
            clearTimeout(refreshPage);
        };
    }, []);

    useEffect(() => {
        fetchNews()
        fetch_meetings()
    }, []);

    // Auto-refresh kiosk when settings change (needUpdate flag on cDevice)
    useEffect(() => {
        if (typeof window === 'undefined') return;
        let cancelled = false;

        const check = async () => {
            if (cancelled) return;
            if (typeof navigator !== 'undefined' && !navigator.onLine) return;
            try {
                const url = `${path}/getReset/${deviceId}?orgID=${encodeURIComponent(ORG_ID_VIENNA_PLZEN)}`;
                const resp = await axios.get(url);
                const need = resp?.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    try {
                        await axios.post(`${path}/updateReset/${deviceId}`, { orgID: ORG_ID_VIENNA_PLZEN });
                    } catch (_) {
                        // ignore
                    }
                    // safest: full reload (settings can affect multiple screens)
                    window.location.reload();
                }
            } catch (_) {
                // ignore
            }
        };

        const onVisibility = () => {
            if (document.visibilityState === 'visible') check();
        };
        document.addEventListener('visibilitychange', onVisibility);
        const interval = setInterval(check, 3000);
        check();

        return () => {
            cancelled = true;
            clearInterval(interval);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [deviceId]);


    const language_handler = () => {
        language == 0 ? setLanguage(1) : setLanguage(0)
    }
    const loader = <CircularProgress color="error" size={100}/>
    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST + FOOTER MENU
    9 - MEETING DETAIL WITHOUT FOOTER
    * */

    const mainMenu = <>
        <div className={classes.bodyContainer}>
            <img src={backMenu}/>
            <div className={classes.circle}/>
            <div className={`${classes.buttonCirc} ${classes.sleepBT}`} onClick={() => {
                setNewStep(1)
            }}>Sleep
            </div>
            <div className={`${classes.buttonCirc} ${classes.eatBT}`} onClick={() => {
                setNewStep(2)
            }}>Eat
            </div>
            <div className={`${classes.buttonCirc} ${classes.meetBT}`} onClick={() => {
                setNewStep(3)
            }}>Meet
            </div>
            <div className={`${classes.buttonCirc} ${classes.exploreBT}`} onClick={() => {
                setNewStep(4)
            }}>Explore
            </div>
            <div className={`${classes.cnnnews}`}>
                <div className={classes.cnnIMG}><img src={cnn}/></div>
                <div className={classes.cnnTXT}><label>{news.length > 0 && news[currentIndexnews]}</label></div>

            </div>
        </div>
        <div className={classes.footerContainer}>
            <video
                src={video}
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                }}
            />
        </div>
    </>

    const setNewStep_handler = (x) => {
        setNewStep(x)
    }

    return <div className={classes.main}>
        {header && <div className={classes.header}>
            <div className={classes.hUp}>
                <div className={classes.box}>
                    <img src={logo} alt={"logo"} onClick={() => {
                        reload_handler()
                    }}/>
                </div>
                <div className={classes.line}></div>
                <div className={classes.boxC}>
                    <img src={cloud}/>
                    <div className={classes.timeC}>{weatherData && `${weatherData}\u00b0`}</div>
                </div>
                <div className={classes.line}></div>
                <div className={classes.boxB}>
                    <div className={classes.timeA}>{actTime}</div>
                    <div className={classes.lineT}>a</div>
                    <div className={classes.timeB}>{actDate}</div>
                </div>
            </div>
        </div>}
        {newstep == 0 && mainMenu}
        {newstep == 1 && <Sleep setStep={setNewStep_handler} reset={resetscreen}/>}
        {newstep == 2 && <Eat setStep={setNewStep_handler} reset={resetscreen}/>}
        {newstep == 3 && <Meet setStep={setNewStep_handler} reset={resetscreen}/>}
        {newstep == 4 && <ExploreVienna setStep={setNewStep_handler} reset={resetscreen}/>}
        {(newstep == 10 || newstep == 11) && <div className={classes.meetGrid}>
            {newstep == 10 && <MeetingGraph language={language} changeStep={changeStep_handler} reset={resetscreen}/>}
            {newstep == 11 && <MeetingStairs changeStep={changeStep_handler} reset={resetscreen}/>}
        </div>}
        {newstep == 12 && <SlideShowKiosk_redesign changeStep={changeStep_handler} groupID={group}/>}

    </div>
}
export default Kiosk_viennaPlzen_redesign